export default __webpack_public_path__ + "static/media/Banner3.0acaccd8.jpg";